import React from 'react';
// Using Lucide icons to match the thin-stroke style in your screenshot
import { Wallet, CircleSlash, BookUser, Landmark, ArrowUpRight } from 'lucide-react';

/**
 * 1. CONFIGURATION DATA
 * Easily add or remove benefits here.
 */
const BENEFITS = [
    {
        id: 1,
        title: "Claim Tax Refund",
        description: "If you have paid more income tax, you are eligible for a tax refund",
        icon: <Wallet className="text-green-600" size={32} />,
    },
    {
        id: 2,
        title: "Avoid Late Filing Fee",
        description: "A delay in filing ITR makes you liable to pay a fee of up to 5,000 INR.",
        icon: <CircleSlash className="text-green-600" size={32} />,
    },
    {
        id: 3,
        title: "Obtaining Visa",
        description: "Foreign consulates may ask you to furnish your income tax returns for obtaining Visa",
        icon: <BookUser className="text-green-600" size={32} />,
    },
    {
        id: 4,
        title: "Easy Loan Approval",
        description: "The income tax return serves as an important document for loan approval",
        icon: <Landmark className="text-green-600" size={32} />,
    },
];

/**
 * 2. SUB-COMPONENT: BENEFIT CARD
 */
const BenefitCard = ({ title, description, icon }) => (
    <div className="bg-white p-8 rounded-3xl shadow-sm border border-gray-50 flex flex-col gap-4">
        <div className="bg-gray-50 w-fit p-3 rounded-xl">
            {icon}
        </div>
        <div>
            <h3 className="text-lg font-bold text-[#1A2B3C] mb-2">{title}</h3>
            <p className="text-gray-500 text-sm leading-relaxed">
                {description}
            </p>
        </div>
    </div>
);

/**
 * 3. MAIN COMPONENT
 */
const BenefitsSection = () => {
    return (
        <section className="bg-[#EEF2F6] py-20 px-6">
            <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-16">

                {/* Left Side: Content & CTA */}
                <div className="lg:w-2/5 space-y-6">
                    <h2 className="text-4xl md:text-5xl font-black text-[#1A2B3C] leading-tight">
                        Benefits of E-Filing ITR with Tax2win's AI Platform
                    </h2>
                    <p className="text-gray-600 text-lg">
                        Effortlessly file your tax returns and enjoy a hassle-free tax season with e-filing
                    </p>
                    <button className="bg-[#417D44] hover:bg-[#356638] text-white px-8 py-4 rounded-full font-bold flex items-center gap-3 transition-all group">
                        File Now
                        <span className="bg-white/20 rounded-full p-1 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform">
                            <ArrowUpRight size={18} />
                        </span>
                    </button>
                </div>

                {/* Right Side: 2x2 Grid */}
                <div className="lg:w-3/5 grid grid-cols-1 md:grid-cols-2 gap-6">
                    {BENEFITS.map((benefit) => (
                        <BenefitCard
                            key={benefit.id}
                            title={benefit.title}
                            description={benefit.description}
                            icon={benefit.icon}
                        />
                    ))}
                </div>

            </div>
        </section>
    );
};

export default BenefitsSection;